import React from 'react';
import { useTranslation } from 'react-i18next';
import IntakeForm from './components/IntakeForm';
import './index.css'; // Ensure Tailwind styles are imported

function App() {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'pt' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="min-h-screen bg-clinic-bg text-clinic-text flex flex-col items-center p-4 font-sans">
      <header className="w-full max-w-4xl bg-white shadow-md rounded-lg p-6 mt-4">
        <div className="flex justify-between items-center mb-6">
          {/* Logo and Company Name */}
          <div className="flex items-center">
            <img src="/images/terrysystem_logo.webp" alt="Terry System Logo" className="h-12 w-auto mr-3" />
            
          </div>

          {/* Language Toggle Button */}
          <button
            onClick={toggleLanguage}
            className="px-4 py-2 bg-clinic-accent text-white rounded-md hover:bg-blue-700 transition-colors shadow"
          >
            {i18n.language === 'en' ? t('toggle.pt') : t('toggle.en')}
          </button>
        </div>

        {/* Form Title */}
        <h1 className="text-3xl font-bold text-clinic-accent text-center">
          {t('form.title')}
        </h1>


      </header>

      {/* Form content will go here */}
      <main className="w-full max-w-4xl bg-white shadow-md rounded-lg p-8 mt-8">
        <IntakeForm />
      </main>

      <footer className="w-full max-w-4xl text-center mt-8 text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} Terry System. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
